<script setup>

import { useForm } from 'vee-validate';
import * as Yup from "yup";

const { $localApi } = useNuxtApp();
const notificationStore = useNotificationStore();

const subscribeSchema = Yup.object({
  firstName: Yup.string().min(2).required().label("First name"),
  lastName: Yup.string().min(2).required().label("Last Name"),
  email: Yup.string().min(3).required().email().label("Email"),
});

const { handleSubmit, errors } = useForm({
  validationSchema: subscribeSchema,
});

const onSubmit = handleSubmit(async (values, { resetForm }) => {
  const { firstName, lastName, email } = values;

  const { data, error } = await $localApi.post(`/addSubscriber`, {
    method: "POST",
    body: { firstName, lastName, email },
  });

  if (error.value || data.value.error) {
    resetForm();
    return;
  }

  notificationStore.ADD({
    type: "success",
    message: 'Thank you for signing up!',
    title: "Success",
  });

  resetForm();
});

</script>

<template>
  <div class="w-full border-t bg-white text-[#0D00FF]">
    <div class="mx-auto flex flex-col gap-y-7 px-5 py-14">
      <p class="text-center text-4xl">Sign Up for Updates</p>
      <form @submit="onSubmit" novalidate>
        <div>
          <label class="w-full" for="firstName">
          <AtomInputField
            id="firstName"
            type="text"
            name="firstName"
            placeholder="First name"
            autocomplete="given-name"
          />
        </label>
        <div v-if="errors.firstName" class="mt-2 block text-sm text-red-600 sm:text-base">{{
          errors.firstName}}
        </div>
        </div>
        <div>
          <label class="w-full" for="lastName">
            <AtomInputField
              id="lastName"
              type="text"
              name="lastName"
              placeholder="Last name"
              autocomplete="family-name"
            />
          </label>
          <div v-if="errors.lastName" class="mt-2 block text-sm text-red-600 sm:text-base">{{
            errors.lastName}}
          </div>
        </div>
        <div>
          <label class="w-full" for="email">
            <AtomInputField
              id="email"
              type="email"
              name="email"
              placeholder="Email"
              autocomplete="email"
            />
          </label>
          <div v-if="errors.email" class="mt-2 block text-sm text-red-600 sm:text-base">{{
            errors.email}}
          </div>
        </div>
        <AtomButton type="submit">
          Sign Up
          <MoleculeNuxtIcon name="Arrow" class="w-4 rotate-180 fill-[#0D00FF]" />
        </AtomButton>
      </form>
    </div>
  </div>
</template>

<style scoped lang="scss">
form {
  @apply flex md:gap-x-7 gap-y-6 mx-auto md:flex-row flex-col;

  & input {
    @apply appearance-none bg-transparent border-b-2 border-[#0D00FF] placeholder:text-2xl placeholder:text-[#0D00FF]/50 lg:text-2xl text-[#0D00FF] outline-none min-w-[255px] md:min-w-[150px] w-full py-2;

    @apply focus-within:invalid:border-b-red-600;
  }

  & .error-msg {
    @apply text-sm hidden;
  }

  & input:focus-within:invalid + .error-msg {
    @apply block text-red-600;
  }

  & button[type='submit'] {
    @apply flex items-center gap-x-4 text-2xl border-2 border-[#0D00FF] rounded-lg py-4 px-14 shrink-0 justify-center;

    & svg {
      @apply fill-[#0D00FF];
    }
  }
}
</style>
